<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{  page_header }}</div>
                <button type="submit" v-on:click.prevent="returnOnListing()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container">
                    <div class="row no-margin">
                        <!--Name-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input id="name" v-model="fields.name" class="form-control" type="text"/>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{name_error_msg}}</span>
                            </div>
                        </div>
                        <!--Location-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="fields.locationId"
                                          name="locationId"
                                          id="locationId"
                                          label="name"
                                          :filterable="true"
                                          :options="locationOption"
                                          @input="onChnageLocation()"
                                          placeholder="Select Location">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{location_error_msg}}</span>
                            </div>
                        </div>
                        <!--Location-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Threshold qty :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input id="threshold_qty" v-model="fields.threshold_qty" class="form-control" type="text"/>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{threshold_qty_error_msg}}</span>
                            </div>
                        </div>
                    </div>

                    <!--Error Alert-->
                    <!-- <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div> -->
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">

                        <input v-if="$route.params.id > 0" id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.saveButton" class="btn btn-primary my-1 ms-2" v-on:click.prevent="updateRecord()">
                        <input v-else id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.saveButton" class="btn btn-primary my-1 ms-2" v-on:click.prevent="createRecord()">
                        <!-- <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary" v-on:click.prevent="updateRecord(flag='Save and Continue')"> -->
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateParts ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary my-1 ms-2" v-on:click.prevent="returnOnListing">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import Footer from '@/components/partials/CustomerFooter';
    import EventBus from '.././event-bus';
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    // import vue2Dropzone from 'vue2-dropzone';
    // import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    /* Vue FlatPickr */
    // import flatPickr from 'vue-flatpickr-component';
    // import 'flatpickr/dist/flatpickr.css';

    /* Bootstrap Data-Picker */
    // import datePicker from 'vue-bootstrap-datetimepicker';
    // import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    //import tinymce from 'vue-tinymce-editor';
    var self;
    export default {
        name: 'Center',
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer': Footer,

            // 'vueDropzone': vue2Dropzone,
            // 'tinymce': tinymce,
            //flatPickr,
            // datePicker,
        },
        data() {
            return {
                page_header:'Add Inventory',
                name_error_msg:'',
                threshold_qty_error_msg:'',
                location_error_msg : "",
                fields:{
                    name:"",
                    threshold_qty:"",
                    locationId: {
                        'name' : "",
                        'id' : "",
                    },
                },
                buttonNames : {
                    saveButton : 'Save',
                    cancel:'Cancel'
                },
                disableButtons : {
                    saveButton : false,
                },
                locationOption : [],
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("customer-menu-selection-changed", "list-inventory");
        },
        mounted: function () {
            self.removeErrorMessageOnInput();
            self.getAllLocationList();
            var id = self.$route.params.id;
            if(id > 0){
                self.buttonNames.saveButton = 'Update';
                self.page_header = 'Edit Inventory';
                self.getRecord();
            }

        },
        methods: {
            onChnageLocation : function () {
                self.location_error_msg = "";
            },
            returnOnListing(){
                self.$router.push({name:'ListInventory'});
            },
            removeErrorMessageOnInput : function () {
                /* Remove error on input */
                $("#name").keyup(function () {
                    self.name_error_msg = "";
                });

                $("#threshold_qty").keyup(function () {
                    self.threshold_qty_error_msg = "";
                });
            },
            getRecord(){
                //alert('here');
                self.disableButtons.saveButton = true;
                var id = self.$route.params.id;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get("inventory/"+id, config)
                    .then(function (data) {
                        //console.log('locationdata', data);
                        if (data.status == 200) {
                            self.fields.name = data.data.name;
                            self.fields.threshold_qty = data.data.threshold_qty;
                            self.fields.locationId.id = data.data.location.id;
                            self.fields.locationId.name = data.data.location.name;
                            self.disableButtons.saveButton = false;
                        }
                    })
                    .catch(function (error) {
                        //self.catchHandler(error);
                    })
            },
            validateForm(){
                var error = false;
                self.name_error_msg = '';
                self.threshold_qty_error_msg = '';

                if(!self.fields.name || self.fields.name == null || self.fields.name == "") {
                    self.name_error_msg = "The name field is required.";
                    error = true;
                }
                if (self.fields.threshold_qty <= 0) {
                    self.threshold_qty_error_msg = "Please enter valid Threshold Qty";
                    error = true;
                }
                if (!self.allnumeric(self.fields.threshold_qty)) {
                    self.threshold_qty_error_msg = "Only Number Allowed";
                    error = true;
                }
                if(!self.fields.threshold_qty || self.fields.threshold_qty == null || self.fields.threshold_qty == "") {
                    self.threshold_qty_error_msg = "The threshold qty field is required.";
                    error = true;
                }

                if(self.allnumeric(self.fields.threshold_qty) && self.fields.threshold_qty > 1000) {
                    self.threshold_qty_error_msg = "Threshold Qty must be less than 1000";
                    error = true;
                }

                if(self.fields.locationId.id == null || self.fields.locationId.id == "") {
                    self.location_error_msg = "The location field is required.";
                    error = true;
                }
                return error;
            },
            allnumeric : function (inputtxt) {
                var numbers = /^\d+$/;;
                if(numbers.test(inputtxt)) {
                    return true;
                } else {
                    return false;
                }
            },
            createRecord(){
                var error = self.validateForm();
                if(!error) {
                    self.disableButtons.saveButton = true;
                    var config = {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("api_token")
                        },
                    };
                    HTTP.post("inventory", self.fields,config)
                        .then(function (data) {
                            //console.log('after create', data)
                            self.buttonNames.saveButton = "Save";
                            self.disableButtons.saveButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/
                            if (data.status == 200) {
                                self.returnOnListing();
                                self.showSAlert('Inventory created successfully','success',false);
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.saveButton = "Save";
                            self.disableButtons.saveButton = false;
                            self.catchHandler(error);
                        })

                }
            },
            updateRecord() {
                var error = self.validateForm();
                var id = self.$route.params.id;

                if(!error) {
                    var config = {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("api_token")
                        },
                    };
                    self.disableButtons.saveButton = true;
                    HTTP.put("inventory/"+id, self.fields,config)
                        .then(function (data) {
                            //console.log('after update', data)
                            self.buttonNames.saveButton = "Update";
                            self.disableButtons.saveButton = false;

                            if (data.status == 200) {
                                self.showSAlert('Inventory updated successfully','success',false);
                            }
                            self.returnOnListing();
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.saveButton = "Update";
                            self.disableButtons.saveButton = false;
                            self.catchHandler(error);
                        })

                }
            },
        }
    }
    EventBus.$on('all-location-list', function (response) {
        if (typeof (self) != 'undefined') {
            self.locationOption = response;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/Inventory/AddUpdateInventory.vue